export default __webpack_public_path__ + "static/media/Ameen.00511d3a.jpg";